__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-bank-permissions-dashboard-root'].baseUrl;
import ModuleContainer from './client/components/PwbDashboard';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}